import React, { useEffect, useState } from 'react';
import './oldGold.scss';
import { GetOldGoldList } from '../../services/oldGold';
import { EyeIcon } from 'lucide-react';
import { CustomLoader } from '../../components/Loader';
import { Link } from 'react-router-dom';

const Leaderboard = () => {

  const [product, setProduct] = useState([])
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    getProduct()
  }, [])
  const getProduct = async () => {
    setLoading(true)
    try {
      const data = await GetOldGoldList();
      console.log(data?.data, "dkmdkk");

      setProduct(data?.data?.message);
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error('Error fetching report data:', error);
    }
  }
  console.log(product, "product?.docs");

  return (
    <div className="leaderboard">
      {
        loading ?
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#f0f0f0',
            flexDirection: 'column'
          }} >
            <CustomLoader />
          </div> :

          <table>
            <thead>
              <tr>
                <th>Scanned Code</th>
                <th>Product Section</th>
                <th>Purity</th>
                <th>Product Description</th>
                <th>Gross Wt(g)</th>
                <th>Net Wt(g)</th>
                <th>Depre. Wt(g)</th>
                <th>Net Wt Af. Depre.(g)</th>
                <th>Total Ded. Amt</th>
                <th>Total</th>
                {/* <th>Edit</th> */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {product?.docs?.map((item, index) => {
                const formatted = new Intl.NumberFormat('en-IN').format(item?.total_amount);

                return <tr key={index}>
                  <td>-</td>
                  <td>{item?.product_section || '-'}</td>
                  <td>{item?.old_gold_item_details[0]?.gold_purity || "-"}</td>
                  <td>{item?.old_gold_item_details[0]?.description || "-"}</td>
                  <td>{item?.old_gold_item_details[0]?.gross_info || '-'}</td>
                  <td>{item?.old_gold_item_details[0]?.net_weight || '-'}</td>
                  <td>{item?.old_gold_item_details[0]?.depreciate_weight || '-'}</td>
                  <td>{item?.old_gold_item_details[0]?.net_weight || '-'}</td>
                  <td>{item.rate_deduction_amount || '-'}</td>
                  <td>{formatted || '-'}</td>
                  <td style={{
                    cursor: "pointer",
                    display: "flex",
                    padding: "10px",
                    justifyContent: "center",
                  }} >
                    <Link to={`/oldgold?id=${item?.name}`} >
                      <span>
                        <EyeIcon />
                      </span>
                    </Link>
                  </td>
                </tr>
              })}
            </tbody>
          </table>}
    </div>
  );
};

export default Leaderboard;
